/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".button-container[_ngcontent-%COMP%]{background-color:#00dbd1;border-radius:8px}.btn-orange[_ngcontent-%COMP%]{font-family:PoppinsSemiBold;color:#00005c;font-size:1rem}.btn-orange[_ngcontent-%COMP%]:hover{text-decoration:none}.btn-orange[_ngcontent-%COMP%]   .dollar-icon[_ngcontent-%COMP%]{font-size:1.25rem}@media (min-width:767px) and (max-width:991px){.button-container[_ngcontent-%COMP%]{background-color:unset}.btn-orange[_ngcontent-%COMP%]{color:#00dbd1}}"];
export { styles as styles };
//# sourceMappingURL=referral-page-link.component.scss.shim.ngstyle.js.map


//////////////////
// WEBPACK FOOTER
// ./ts/app/header/referral-page-link/referral-page-link.component.scss.shim.ngstyle.js
// module id = 1465
// module chunks = 27 28 29